import qs from 'query-string'

export async function sendRequest(values) {
  const url = new URL(`${process.env.REACT_APP_USER_URI}`)
  const body = JSON.stringify(values)
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    })
    if (response.ok) {
      return await response.json()
    } else {
      const contentType = response.headers.get('content-type')
      const isJson =
        contentType && contentType.indexOf('application/json') !== -1
      throw isJson ? await response.json() : await response.text()
    }
  } catch (err) {
    throw new Error(err)
  }
}

export async function updateValues({
  userId,
  requestType,
  requestId,
  ...values
}) {
  const url = new URL(`${process.env.REACT_APP_USER_URI}`)
  const body = JSON.stringify({
    userId,
    requestType,
    requestId,
    ...values,
  })
  try {
    const response = await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    })
    if (response.ok) {
      return await response.json()
    } else {
      const contentType = response.headers.get('content-type')
      const isJson =
        contentType && contentType.indexOf('application/json') !== -1
      throw isJson ? await response.json() : await response.text()
    }
  } catch (err) {
    throw new Error(err)
  }
}

export async function getTracksInfo(str) {
  const { selection } = qs.parse(str)
  const url = new URL(`${process.env.REACT_APP_SEARCH_URI}?slug=${selection}`)
  const res = await fetch(url)
  if (res.ok) {
    return await res.json()
  } else {
    return await Promise.reject(res.statusText)
  }
}

export async function getUserInfo(email) {
  const queryString = qs.stringify({ email }, { skipNull: true })
  const url = new URL(`${process.env.REACT_APP_USER_URI}?${queryString}`)
  const res = await fetch(url)
  if (res.ok) {
    return await res.json()
  } else {
    return await Promise.reject(res.statusText)
  }
}

export async function getAuthLink(email) {
  const queryString = qs.stringify({ email }, { skipNull: true })
  const url = new URL(`${process.env.REACT_APP_USER_URI}/auth?${queryString}`)
  const res = await fetch(url)
  if (res.ok) {
    return await res.json()
  } else {
    return await Promise.reject(res.statusText)
  }
}

export async function checkAuthToken(token) {
  const url = new URL(`${process.env.REACT_APP_USER_URI}/token`)
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
  })
  if (res.ok) {
    return await res.json()
  } else {
    return await Promise.reject(res.statusText)
  }
}

export async function downloadDocument({ userId, id, kind = 'license' }) {
  const queryString = qs.stringify({ id, userId }, { skipNull: true })
  const url = new URL(
    `${process.env.REACT_APP_DOWNLOAD_URI}/get-${kind}?${queryString}`
  )
  return await forceDownload(
    url,
    `Pixeden_Music_${kind}_${id.replace('purchased_', '')}.pdf`
  )
}

export async function forceDownload(url, filename) {
  const res = await fetch(url)
  if (res.ok) {
    return res.blob().then((blob) => {
      var url = window.URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(url)
    })
  } else {
    return await Promise.reject(res.statusText)
  }
}

export async function toggleRequest(email, type, id) {
  const url = new URL(`${process.env.REACT_APP_QUOTE_URI}`)
  const body = JSON.stringify({ email, requestId: id, requestType: type })
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }).then((res) => res.json())
}

export async function sendMessage({ userId, type, id, message }) {
  const url = new URL(`${process.env.REACT_APP_MESSAGE_URI}`)
  const body = JSON.stringify({
    userId,
    requestId: id,
    requestType: type,
    message,
  })
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }).then((res) => res.json())
}

export async function makePayment({
  userId,
  name,
  artist,
  amount,
  requestType,
  requestId,
  nonce,
}) {
  const url = new URL(`${process.env.REACT_APP_PAYMENT_URI}`)
  const body = JSON.stringify({
    userId,
    name,
    artist,
    amount,
    requestType,
    requestId,
    nonce,
  })
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    })
    if (response.ok) {
      return await response.json()
    } else {
      const contentType = response.headers.get('content-type')
      const isJson =
        contentType && contentType.indexOf('application/json') !== -1
      throw isJson ? await response.json() : await response.text()
    }
  } catch (err) {
    throw new Error(err)
  }
}
